import React from "react";

export const BlogPostIllustration: React.SFC = (props) => (
  <svg viewBox="0 0 359 385" fill="none" {...props}>
    <path
      d="M356.693 311.133v70.592H62.641c-11.417-18.707-18.055-41.079-18.055-65.094 0-65.757 49.77-119.128 111.195-119.128h15.37c-29.06 0-52.308 26.164-52.308 57.289s23.573 56.341 52.604 56.341h185.246z"
      fill="#F17A5D"
    />
    <path
      d="M356.693 2v309.133H171.447c-29.031 0-52.603-25.216-52.603-56.341s23.248-57.289 52.308-57.289H219.448c64.964 0 117.774-55.456 117.774-125.006 0-26.132-7.435-50.4-20.121-70.497h39.592z"
      fill="#6A80EF"
    />
    <path
      d="M317.101 2c12.686 20.097 20.121 44.365 20.121 70.497 0 69.55-52.81 125.006-117.774 125.006H155.781c-61.424 0-111.195 53.371-111.195 119.128 0 24.015 6.638 46.387 18.056 65.094h-3.275c-23.484-28.629-37.704-66.137-37.704-107.247 0-89.804 67.974-162.64 151.879-162.64H233.845c42.071-.253 76.146-36.876 76.146-81.968 0-9.795-1.593-19.18-4.543-27.87h11.653z"
      fill="#FDE8DF"
    />
    <path
      d="M305.447 2c2.951 8.69 4.544 18.075 4.544 27.87 0 45.092-34.076 81.715-76.146 81.968h-40.183v-.411c29.827 0 53.99-25.91 53.99-57.889 0-22.467-11.949-41.963-29.473-51.538h87.268z"
      fill="#F17A5D"
    />
    <path
      d="M218.179 2c17.524 9.575 29.473 29.071 29.473 51.538 0 31.978-24.163 57.889-53.99 57.889v.411h-20.121c-83.905 0-151.879 72.836-151.879 162.64 0 41.11 14.22 78.618 37.705 107.247H2.16V2H218.18z"
      fill="#6A80EF"
    />
    <path
      d="M62.641 381.725a121.525 121.525 0 0011.27 15.515 155.488 155.488 0 01-14.545-15.515h3.275z"
      fill="#FDE8DF"
    />
    <path
      d="M317.101 2h39.592V381.725H62.642"
      stroke="#1D1D1B"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M59.367 381.725H2.16V2h317.194"
      stroke="#1D1D1B"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M62.641 381.725c-11.417-18.707-18.055-41.079-18.055-65.094 0-65.757 49.77-119.128 111.195-119.128h15.37"
      stroke="#1D1D1B"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M317.408 2.285c12.686 20.097 20.12 44.365 20.12 70.497 0 69.55-52.809 125.006-117.774 125.006H171.458c-29.06 0-52.308 26.164-52.308 57.289s23.573 56.341 52.603 56.341H357"
      stroke="#1D1D1B"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M193.662 111.427c29.827 0 53.99-25.91 53.99-57.889 0-22.467-11.949-41.963-29.473-51.538M305.447 2c2.951 8.69 4.544 18.075 4.544 27.87 0 45.092-34.076 81.715-76.146 81.968"
      stroke="#1D1D1B"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M233.845 111.838h-60.303c-83.905 0-151.88 72.836-151.88 162.64 0 41.11 14.22 78.618 37.705 107.247"
      stroke="#1D1D1B"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
  </svg>
);
